module.exports = __webpack_public_path__ + "static/media/spa.c7ea6b72.svg";